import React from "react";

import TimeslotRuleItem from "./TimeslotRuleItem";
import {
  TimeslotRuleAdbreakSelect,
  TimeslotRuleSingleCountSelect,
} from "./TimeslotRuleItemSelect";
import { TimeslotColumns } from "../../../types";

import type { JSX } from "react";
import type { ConnectDragSource } from "react-dnd";

import type { TimeslotAdbreakRule } from "../../../api/FastAPI.types";

interface TimeslotRuleAdbreakProps {
  rule: TimeslotAdbreakRule;
  onClickDelete: (uuid: string) => void;
  isDragging: boolean;
  isDragDisabled: boolean;
  dragRef: ConnectDragSource;
}

function TimeslotRuleAdbreak({
  rule,
  onClickDelete,
  isDragging,
  dragRef,
  isDragDisabled,
}: TimeslotRuleAdbreakProps): JSX.Element {
  const columns = {
    [TimeslotColumns.Rank]: rule.rank,
    [TimeslotColumns.Mode]: rule.mode,
    [TimeslotColumns.Source]: <TimeslotRuleAdbreakSelect ruleId={rule.uuid} />,
    [TimeslotColumns.Count]: <TimeslotRuleSingleCountSelect />,
  };
  return (
    <TimeslotRuleItem
      columns={columns}
      dragRef={dragRef}
      isDragDisabled={isDragDisabled}
      isDragging={isDragging}
      onClickDelete={onClickDelete}
      uuid={rule.uuid}
    />
  );
}

export default TimeslotRuleAdbreak;
